import { RouteConfig } from 'vue-router';
import Invites from '@/views/invites/Invites.vue';
import Partner from '@/views/invites/Partner.vue';
import store from '@/store';
import hasAffiliateAccess from '@/views/invites/utils/hasAffiliateAccess';

const routes: Array<RouteConfig> = [
  {
    path: '/invites',
    name: 'invites',
    component: Invites,
    meta: {
      auth: true,
      layout: 'full',
    },
  },
  {
    path: '/partner',
    name: 'partner',
    component: Partner,
    meta: {
      auth: true,
      layout: 'full',
    },
    beforeEnter(_to, _from, next) {
      if (hasAffiliateAccess(store.getters.user?.roles)) {
        next();
        return;
      }
      next({ name: 'invites' });
    }
  },
];

export default routes;
